import React from 'react';

/**
 * Menu das Configurações: coluna vertical agrupada no desktop e grade de
 * botões no celular — todas as seções visíveis, sem barra de rolagem.
 *
 * groups: [{ title, items: [{ id, label, icon }] }]
 */
export default function SettingsNav({ groups, active, onChange, accentColor = '#6366F1' }) {
  return (
    <nav
      className="lg:w-60 lg:flex-shrink-0 space-y-4 lg:sticky lg:top-4"
      aria-label="Seções das configurações"
      data-testid="settings-nav"
    >
      {groups.map((group) => (
        <div key={group.title}>
          <p className="px-1 mb-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-400">
            {group.title}
          </p>
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-1.5 p-1.5 rounded-2xl bg-slate-100/80 dark:bg-slate-900/70 border border-slate-200/70 dark:border-slate-800">
            {group.items.map(({ id, label, icon: Icon }) => {
              const isActive = active === id;
              return (
                <button
                  key={id}
                  type="button"
                  onClick={() => onChange(id)}
                  aria-current={isActive ? 'page' : undefined}
                  data-testid={`tab-${id}`}
                  className={`flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-xs sm:text-[13px] font-semibold text-left transition-all duration-200 cursor-pointer ${
                    isActive
                      ? 'bg-white dark:bg-slate-800 shadow-sm border border-slate-200/60 dark:border-slate-700/80'
                      : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-white/60 dark:hover:bg-slate-800/40 border border-transparent'
                  }`}
                  style={isActive ? { color: accentColor } : undefined}
                >
                  {Icon && <Icon size={16} className="flex-shrink-0" />}
                  <span className="leading-tight">{label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </nav>
  );
}
